import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import * as ApplicationStandAloneActions from "@Client/@Modules/application-standalone/store/application-standalone-actions";
import { useApplicationStandaloneStoreActions } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { APPLICATION_PATH } from "@Client/@Utils/enums/application-paths";
import { computed } from "@vue/composition-api";
export const useOtherPropertiesFieldBindings = options => {
  const {
    TRANSFER_APPLICANT_FIELD_BY_PATH
  } = useApplicationStandaloneStoreActions([ApplicationStandAloneActions.TRANSFER_APPLICANT_FIELD_BY_PATH]);
  const {
    bindApplication,
    bindAddressField,
    makeFieldPathReactive
  } = useBindApplication();
  const {
    currentApplicantPath
  } = useApplicantFieldBindings({
    applicantIndex: options.applicantIndex
  });
  const existingMortgageIndex = computed(() => {
    var _options$existingMort;
    return (_options$existingMort = options.existingMortgageIndex) == null ? void 0 : _options$existingMort.value;
  });
  const propertyOwner = computed({
    get() {
      return options.applicantIndex.value;
    },
    set(newApplicantIndex) {
      if (typeof newApplicantIndex !== "number") return;
      const sourcePath = currentApplicantPath.value + "[other-properties]";
      const applicantPath = newApplicantIndex === 0 ? APPLICATION_PATH.MAIN_APPLICANT : `${APPLICATION_PATH.CO_APPLICANTS}[${newApplicantIndex - 1}]`;
      const targetPath = applicantPath + "[other-properties]";
      TRANSFER_APPLICANT_FIELD_BY_PATH({
        sourcePath,
        targetPath,
        sourceElementIndex: options.otherPropertyIndex.value
      });
    }
  });
  const otherPropertyFromApplicant = bindApplication(currentApplicantPath.value + "[other-properties]" + "[" + options.otherPropertyIndex.value + "]", {});
  const otherPropertyPath = computed(() => {
    return currentApplicantPath.value + "[other-properties]" + "[" + options.otherPropertyIndex.value + "]";
  });
  const existingMortgagePath = computed(() => {
    return otherPropertyPath.value + "[other-property-existing-mortgages]" + "[" + existingMortgageIndex.value + "]";
  });
  const purchasePrice = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-details][purchase-price]"), 0);
  const estimatedValue = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-details][estimated-value]"), 0);
  const purchaseDate = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-details][purchase-date]"), "");
  const address = bindAddressField(makeFieldPathReactive(otherPropertyPath, "[property-details][address]"));
  const feesIncludeHeat = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-costs][fees-include-heat]"), null);
  const heating = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-costs][heating]"), 0);
  const includeInTds = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-costs][include-in-tds]"), null);
  const maintenanceFees = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-costs][maintenance-fees]"), 0);
  const percOfTotalMaintFees = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-costs][perc-of-total-maint-fees]"), 0);
  const propertyTaxes = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-costs][property-taxes]"), 0);
  const hydro = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-rental][hydro]"), 0);
  const insurance = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-rental][insurance]"), 0);
  const interest = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-rental][interest]"), 0);
  const management = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-rental][management]"), 0);
  const monthlyIncome = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-rental][monthly-income]"), 0);
  const occupancy = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-rental][occupancy]"), "");
  const others = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-rental][others]"), 0);
  const rentalIncomeOptions = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-rental][rental-income-options]"), "");
  const rentalIncomeOptionsPercent = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-rental][rental-income-options-percent]"), 0);
  const repairs = bindApplication(makeFieldPathReactive(otherPropertyPath, "[property-rental][repairs]"), 0);
  const existingMortgageBalanceRemaining = bindApplication(makeFieldPathReactive(existingMortgagePath, "[balance-remaining]"), 0);
  const existingMortgageFrequency = bindApplication(makeFieldPathReactive(existingMortgagePath, "[frequency]"), "");
  const existingMortgageInterestRate = bindApplication(makeFieldPathReactive(existingMortgagePath, "[interest-rate]"), 0);
  const existingMortgageLender = bindApplication(makeFieldPathReactive(existingMortgagePath, "[lender]"), "");
  const existingMortgageLoanType = bindApplication(makeFieldPathReactive(existingMortgagePath, "[loan-type]"), "");
  const existingMortgageMaturityDate = bindApplication(makeFieldPathReactive(existingMortgagePath, "[maturity-date]"), "");
  const existingMortgageMortgageType = bindApplication(makeFieldPathReactive(existingMortgagePath, "[mortgage-type]"), "");
  const existingMortgageOrigAmount = bindApplication(makeFieldPathReactive(existingMortgagePath, "[orig-amount]"), 0);
  const existingMortgagePaymentAmount = bindApplication(makeFieldPathReactive(existingMortgagePath, "[payment-amount]"), 0);
  const existingMortgagePayoff = bindApplication(makeFieldPathReactive(existingMortgagePath, "[payoff]"), "");
  const existingMortgageRateType = bindApplication(makeFieldPathReactive(existingMortgagePath, "[rate-type]"), "");
  const existingMortgageTermType = bindApplication(makeFieldPathReactive(existingMortgagePath, "[term-type]"), "");
  return {
    purchasePrice,
    estimatedValue,
    purchaseDate,
    address,
    propertyOwner,
    feesIncludeHeat,
    heating,
    includeInTds,
    maintenanceFees,
    percOfTotalMaintFees,
    propertyTaxes,
    hydro,
    insurance,
    interest,
    management,
    monthlyIncome,
    occupancy,
    others,
    rentalIncomeOptions,
    rentalIncomeOptionsPercent,
    repairs,
    existingMortgageBalanceRemaining,
    existingMortgageFrequency,
    existingMortgageInterestRate,
    existingMortgageLender,
    existingMortgageLoanType,
    existingMortgageMaturityDate,
    existingMortgageMortgageType,
    existingMortgageOrigAmount,
    existingMortgagePaymentAmount,
    existingMortgagePayoff,
    existingMortgageRateType,
    existingMortgageTermType,
    otherPropertyFromApplicant
  };
};